module.exports = __webpack_public_path__ + "fb4a5fcc89dae5065fb8c49508a40978.jpg";